import { cn } from '@/lib/utils';

type BubbleSpec = {
  role: 'user' | 'assistant';
  lines: Array<string | number>;
};

const BUBBLES: BubbleSpec[] = [
  { role: 'user', lines: [180, 120] },
  { role: 'assistant', lines: ['92%', '78%', '64%', 160] },
  { role: 'user', lines: [140] },
  { role: 'assistant', lines: ['85%', '70%', 200] }
];

type McpChatThreadPreloadProps = {
  isDark?: boolean;
  className?: string;
};

/** Full-page skeleton while a history thread (`/chat/c/:id`) is loading. */
export function McpChatThreadPreload({
  isDark = false,
  className
}: McpChatThreadPreloadProps) {
  return (
    <div
      className={cn('mcp-chat-page aui-root', isDark && 'dark', className)}
      data-theme={isDark ? 'dark' : 'light'}
      role="status"
      aria-busy="true"
      aria-label="در حال بارگذاری گفتگو"
    >
      <div className="mcp-chat-main">
        <header className="mcp-chat-header placeholder-glow">
          <div className="d-flex align-items-center gap-2 min-w-0">
            <span
              className="placeholder rounded flex-shrink-0"
              style={{ width: 32, height: 32 }}
            />
            <span
              className="placeholder rounded"
              style={{ width: 160, height: 16 }}
            />
          </div>
          <div className="d-flex align-items-center gap-1.5">
            <span
              className="placeholder rounded"
              style={{ width: 32, height: 28 }}
            />
            <span
              className="placeholder rounded"
              style={{ width: 72, height: 28 }}
            />
            <span
              className="placeholder rounded"
              style={{ width: 96, height: 28 }}
            />
          </div>
        </header>

        <div className="mcp-chat-thread">
          <div className="aui-root aui-thread-root bg-background flex h-full flex-col">
            <div className="relative flex flex-1 flex-col overflow-hidden">
              <div className="mx-auto flex w-full max-w-[50rem] min-w-0 flex-1 flex-col gap-y-6 px-4 pt-4 sm:px-6 placeholder-glow">
                {BUBBLES.map((bubble, index) =>
                  bubble.role === 'user' ? (
                    <div
                      key={index}
                      className="ms-auto flex w-fit max-w-[70%] flex-col gap-y-2 rounded-xl px-3 py-2.5"
                      style={{
                        background: 'var(--user-bubble, var(--muted, rgba(0,0,0,0.04)))'
                      }}
                    >
                      {bubble.lines.map((width, lineIndex) => (
                        <span
                          key={lineIndex}
                          className={cn(
                            'placeholder rounded d-block',
                            lineIndex > 0 && 'mt-2'
                          )}
                          style={{
                            width,
                            height: 12,
                            maxWidth: '100%'
                          }}
                        />
                      ))}
                    </div>
                  ) : (
                    <div key={index} className="flex flex-col gap-y-2">
                      {bubble.lines.map((width, lineIndex) => (
                        <span
                          key={lineIndex}
                          className="placeholder rounded d-block"
                          style={{
                            width,
                            height: 14,
                            maxWidth: '100%'
                          }}
                        />
                      ))}
                    </div>
                  )
                )}
              </div>

              <div className="aui-thread-viewport-footer bg-background relative mt-auto flex flex-col gap-4 overflow-visible px-4 pb-4 sm:px-6 md:pb-6">
                <div
                  className="placeholder-glow mx-auto w-full max-w-[50rem]"
                  aria-hidden
                >
                  <span
                    className="placeholder rounded-4 d-block"
                    style={{ width: '100%', height: 88 }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
